"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseTagColorEnum = void 0;
var ExpenseTagColorEnum;
(function (ExpenseTagColorEnum) {
    ExpenseTagColorEnum[ExpenseTagColorEnum["GREEN"] = 0] = "GREEN";
    ExpenseTagColorEnum[ExpenseTagColorEnum["BLUE"] = 1] = "BLUE";
    ExpenseTagColorEnum[ExpenseTagColorEnum["RED"] = 2] = "RED";
    ExpenseTagColorEnum[ExpenseTagColorEnum["YELLOW"] = 3] = "YELLOW";
    ExpenseTagColorEnum[ExpenseTagColorEnum["PURPLE"] = 4] = "PURPLE";
})(ExpenseTagColorEnum || (exports.ExpenseTagColorEnum = ExpenseTagColorEnum = {}));
